<template lang="pug">
#gestao-contratos-originacao-subempresa
    BaseHeader(
            titulo='Gestão de contratos de originação',
            :exibeBotao="false"
        )

    .view-container.margen-bottom-pages
        .bloco-pesquisa-filtros
            BlocoPesquisaFiltros(
                @emitFiltros="adicionarFiltros")

        .bloco-infor-dados
            SkeletonBlocoInforDadosGestao( :carregando="skeletonBlocoInforDados" )
                BlocoInforDadosGestao(
                    titulo="Números de contratos de originação"
                    :numero="totalContratosOriginacao.totalContratosOriginacao"
                )
                    template(slot='icone')
                        i.mdi.mdi-swap-horizontal-bold

            SkeletonBlocoInforDadosGestao( :carregando="skeletonBlocoInforDados" )
                BlocoInforDadosGestao(
                    titulo="Número de imóveis"
                    :numero="totalContratosOriginacao.totalImoveis"
                )
                    template(slot='icone')
                        i.mdi.mdi-home-variant-outline

            SkeletonBlocoInforDadosGestao( :carregando="skeletonBlocoInforDados" )
                BlocoInforDadosGestao(
                    titulo="Volume contratado"
                    :numero="totalContratosOriginacao.totalVolumeContratado"
                    sigla="t"
                )
                    template(slot='icone')
                        i.mdi.mdi-chart-bar

            SkeletonBlocoInforDadosGestao( :carregando="skeletonBlocoInforDados" )
                BlocoInforDadosGestao(
                    titulo="Volume entregue "
                    :numero="totalContratosOriginacao.totalVolumeEntregue"
                    sigla="t"
                )
                    template(slot='icone')
                        i.mdi.mdi-chart-bar

        .bloco-novos-contratos-preenchimento( v-if="totalContratosOriginacao && totalContratosOriginacao.totalNovosContratos > 0" )
            BaseAlertasBloco
                p
                    strong.total-contratos(v-if="totalContratosOriginacao.totalNovosContratos === 1") {{ totalContratosOriginacao.totalNovosContratos }}
                    | Novos contratos de originação aguardando preenchimento
                    strong.total-contratos(v-if="totalContratosOriginacao.totalNovosContratos !== 1") {{ totalContratosOriginacao.totalNovosContratos }}
                    | Novos contratos de originação aguardando preenchimento

        .secao-listagem-filtro-sub-empresa
            .titulo-listagem
                h3 Listagem de contratos cadastrados

            .check-campos-erros
                el-checkbox(
                    v-model="CheckListagemContratoErro"
                    @change="contratosErros")
                    | Mostrar apenas contratos aguardando preenchimento

        .bloco-novos-contratos-tabela
            TabelaGestaoContratoOriginacao(
                    :tabelaData="contratosTabela"
                    :carregando="carregandoTabela"
                    :paginacao="paginacao"
                    @mudarPagina='mudarPagina'
                    @ordenarTabela="ordenarTabela")

</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import BaseAlertasBloco from '@/components/BaseAlertasBloco';
import BlocoInforDadosGestao from '@/components/contrato/BlocoInforDadosGestao';
import SkeletonBlocoInforDadosGestao from '@/components/contrato/SkeletonBlocoInforDadosGestao.vue';
import TabelaGestaoContratoOriginacao from '@/components/contrato/TabelaGestaoContratoOriginacao';
import BlocoPesquisaFiltros from '@/components/contrato/BlocoPesquisaFiltros';
import Revenda from '@/services/Revenda';

export default {
    name: 'GestaoContratosOriginacao',
    components: {
        BaseHeader,
        BaseAlertasBloco,
        BlocoInforDadosGestao,
        SkeletonBlocoInforDadosGestao,
        TabelaGestaoContratoOriginacao,
        BlocoPesquisaFiltros
    },
    data() {
        return {
            totalContratosOriginacao: {
                totalContratosOriginacao: null,
                totalImoveis: null,
                totalVolumeContratado: null,
                totalVolumeEntregue: null,
                totalNovosContratos: null
            },
            contratosTabela: [],
            paginacao: {},
            params: {
                page: 0,
                size: 20,
                sort: 'statusSubEmpresa',
                por: 'desc'
            },
            filtro: {
                numeroContrato: '',
                idsCultura: [],
                idsSafra: [],
                codigosStatus: [],
                dataContrato: ''
            },
            skeletonBlocoInforDados: true,
            CheckListagemContratoErro: false,
            carregandoTabela: false
        };
    },
    mounted() {
        this.buscarTotalizadores();
        this.buscarContratosRevenda();
    },
    methods: {
        async buscarTotalizadores() {
            try {
                const { data } = await Revenda.totalizadores();
                this.totalContratosOriginacao = {...data};
            } catch (error) {
                this.$notify.error({
                    message:
                        'Não foi possível buscar os dados de totalizadores.'
                });
            }
            this.skeletonBlocoInforDados = false;
        },
        async buscarContratosRevenda() {
            this.carregandoTabela = true;
            try {
                const { data } = await Revenda.contratos(this.filtro, this.params);
                this.contratosTabela = data.itens;
                this.paginacao = data.paginacao;
            } catch (error) {
                this.$notify.error({
                    message:
                        'Não foi possível buscar os dados de contrato.'
                });
            }
            this.carregandoTabela = false;
        },
        mudarPagina(novaPagina) {
            this.paginacao.pagina = novaPagina;
            this.params.page = novaPagina;
            this.buscarContratosRevenda();
        },
        ordenarTabela(column) {
            this.params.sort = column.prop;
            this.params.por = column.order;
            this.buscarContratosRevenda();
        },
        adicionarFiltros(filtro) {
            this.filtro.dataContrato = filtro.dataCadastro;
            this.filtro.idsCultura = filtro.culturas;
            this.filtro.idsSafra = filtro.safras;
            this.filtro.codigosStatus = filtro.status;
            this.filtro.numeroContrato = filtro.pesquisa;
            this.buscarContratosRevenda();
        },
        contratosErros() {
            
            if (this.CheckListagemContratoErro) {
                this.filtro.codigosStatus = ['PROCESSADO_INCONFORMIDADE'];
            } else {
                this.filtro.codigosStatus = [];
            }
            this.buscarContratosRevenda();
        }
    }
};

</script>

<style lang="scss">
#gestao-contratos-originacao-subempresa {
    .bloco-infor-dados {
        display: flex;
        justify-content: space-between;
        gap: 11px;
        width: 100%;
        flex-wrap: wrap;
        & > div {
            flex-grow: 1;
        }
    }
    .bloco-novos-contratos-preenchimento, .bloco-infor-dados, .bloco-pesquisa-filtros, .bloco-novos-contratos-tabela{
        margin-top: 20px;
    }
    .total-contratos {
        font-size: 19px;
        margin-right: 6px;
    }
    .secao-listagem-filtro-sub-empresa {
        display: flex;
        margin-top: 25px;
        justify-content: space-between;
        .el-checkbox__label, .titulo-listagem h3 {
            font-weight: bold;
        }
    }
}
@media only screen and (max-width: 1200px) {
    .bloco-infor-dados > div {
        width: 49%;
    }
}
</style>
